import React from "react"
import Link from "gatsby-link"

import BigSlidePanel from "../BigSlidePanel"

class BigSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = { idx: 0 }
  }

  render() {
    return (
      <div>
        <div className="mod modDefaultSlider">
          <div className="sequence" data-autostop="off" data-timeout="4000">
            <div
              className="sequence-prev"
              onClick={() => {
                this.setState({ idx: (this.state.idx + 1) % 2 })
              }}
            >
              <span />
            </div>
            <a
              className="sequence-next"
              onClick={() => {
                this.setState({ idx: (this.state.idx + 1) % 2 })
              }}
            >
              <span />
            </a>
            <ul className="sequence-pagination">
              <li className="" />
              <li className="current" />
            </ul>
            <ul className="sequence-canvas">
              {this.props.imageList.map((image, i) => (
                <BigSlidePanel
                  key={i}
                  image={image}
                  isActive={i === this.state.idx}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default BigSlider



// WEBPACK FOOTER //
// ./src/components/BigSlider/index.js